export const GEMINI_API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent';
export const GEMINI_API_KEY = 'AIzaSyAJ5ZkMMChIAhuJzYjIVmWS1xrBb-TymIA'; // Replace with your actual API key 